import { render, staticRenderFns } from "./PleitoDadosGerais.vue?vue&type=template&id=2b02af3f"
import script from "./PleitoDadosGerais.vue?vue&type=script&lang=js"
export * from "./PleitoDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports